import React from 'react'

import InnerBanner from './InnerBanner'
import CategoryActivities from './CategoryActivities'

export default function About() {
  return (
    <>
    <InnerBanner />
    {/* <TreatmentSection showAll={true} /> */}
    <CategoryActivities />
    </>
  )
}
